import { Injectable } from '@angular/core';

import { DataTaskService } from '@app/core/services/data-task.service';

@Injectable({ providedIn: 'root' })
export class EdiDestinationService {
    constructor(private dataTask: DataTaskService) {}

    /**
     * @datatask 987
     * @datataskName sp_ws_p2_edi_destination_list
     * @param params EDI destination list parameters.
     * @returns Promise containing the available EDI destinations.
     */
    public getEdiDestinationsList(params: EdiDestinationListParams): Promise<EdiDestinationListItem[]> {
        return this.dataTask.Post(987, params);
    }
}

export interface EdiDestinationListParams {}

export interface EdiDestinationListItem {
    item_id: string | number;
    item_name: string;
}
